/**
 * Configuration for device overview sections.
 * Set to `true` to show a section, `false` to hide it.
 */
export const DEVICE_OVERVIEW_SECTIONS = {
  deviceInfo: true,
  network: false,
  timeline: true,
  storage: false,
  realtimeMetrics: true,
  quickCommands: true,
} as const;
